import { RECOVERY_REASON } from '../components/subscription-recovery/types/subscription-recovery-enums';
import { useOnboardingLadder } from '@/features/setup/hooks/use-onboarding-ladder';
import { isSubscriptionOnTrial, shouldDeferBillingToOnboarding } from '@/features/setup/helpers/top-bar-notice';
import { useAccountState } from '@/contexts/account/account-context';

export function useShouldDeferBillingToOnboarding(
  recoveryReason: RECOVERY_REASON | null
): boolean {
  const { currentAccount } = useAccountState();
  const ladder = useOnboardingLadder();

  // Don't check isError — cached data is still valid after a refetch failure,
  // and the ladder is built from cache. Only defer when we have a real nextStep.
  return shouldDeferBillingToOnboarding({
    isTrialing: isSubscriptionOnTrial(currentAccount?.subscription),
    onboardingIncomplete: ladder.nextStep !== null,
    recoveryReason,
  });
}
